import React, {SyntheticEvent} from 'react';
import {useLocation} from "wouter";
import type {IconButtonProps} from "../IconButton/IconButton";
import IconButton from "../IconButton/IconButton";
import ErrorBoundaryO from "@/ErrorBoundary/ErrorBoundaryO";

const RoutedIconButton = (props: RoutedIconButtonProps) => {
    const [, navigate] = useLocation();

    const _onClick = (e: SyntheticEvent) => {
        props.onClick?.(e);
        navigate(props.route);
    };

    return <ErrorBoundaryO uniqueKey={props.route} shouldUseErrorIcon={true}>
        <IconButton {...props} onClick={_onClick} useDelay={true}/>
    </ErrorBoundaryO>
};

export type RoutedIconButtonProps = IconButtonProps & {
    route: string,
    onClick?: (e: SyntheticEvent) => void,
}

export default RoutedIconButton;